// import React from "react";
// import { Row, Col, Container } from "react-bootstrap";
// import Media from "react-media";
// import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
// import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
// import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import ReUsableOnlineEventDashboard from "./ReUsableOnlineEventDashboard";

// const OnlineEventDetails = (props) => {
//   return (
//     <React.Fragment>
//       <Container fluid>
//         <Row>
//           <Media query="(min-width: 992px)">
//             <div className="left-side-panel">
//               <LeftSideNavigation />
//             </div>
//           </Media>

//           <div className="right-side-panel super-admin-right-side-panel">
//             <RightSideNavigation
//               leftText="vendorReview"
//               backButtonLink="/event"
//               displayText="back"
//             />
//             <Col lg={12}>
//               <div className="f24_700_HelveticaNeue pb-4">Event Dashboard</div>
//               <ReUsableOnlineEventDashboard sendData={props.} />
//             </Col>
//           </div>
//           <Media query="(max-width: 991px)">
//             <div className="bottom-panel">
//               <BottomNavigationMobile />
//             </div>
//           </Media>
//         </Row>
//       </Container>
//     </React.Fragment>
//   );
// };
// export default OnlineEventDetails;

import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import HomeReusableTopBarNavigation from "../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Col, Row, Image, Table } from "react-bootstrap";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { CountBoxReusableSeatingComponent } from "../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import moment from "moment";
import { get_online_event } from "../../../store/actions/SuperAdminActions/commonSuperAdmin";
import { get_view_dashboard_online_event } from "../../../store/actions/vendorOffersAndEventsAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import { useParams } from "react-router-dom";

const OnlineEventDetails = (props) => {
  const { id } = useParams();
  const onSuccess = () => {};
  useEffect(() => {
    const token = props.auth.user.accessToken;
    const vendorID = props.auth.user.VendorUser._id;
    props.get_view_dashboard_online_event(token, vendorID, id, onSuccess);
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="mobile-right-side-panel super-admin-right-side-panel">
                <div className="super-admin-inside-right-side-panel">
                  <RightSideNavigation
                    leftText="vendorReview"
                    backButtonLink="/event"
                    displayText="Back"
                  />
                  <div class="f24_700_HelveticaNeue pb-4">Event Dashboard</div>
                  <MainEventsOnlineView
                    userData={props.online_event}
                    event={props.event_details}
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

OnlineEventDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  get_view_dashboard_online_event: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  online_event: state.offersevents.get_view_online_events,
  event_details: state.offersevents.set_all_online_event,
});

export default connect(mapStateToProps, {
  get_view_dashboard_online_event,
})(OnlineEventDetails);

const MainEventsOnlineView = (props) => {
  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");

  const sortBy = [
    { id: 1, title: "Today" },
    { id: 2, title: "Last month" },
    { id: 3, title: "Last 3 months" },
    { id: 4, title: "ALL" },
  ];

  const changeSortByDay = (e) => {
    setSortByDay(e);
    let startDate = "";
    let endDate = new Date();
    if (e === 2) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 1) {
      startDate = new Date();
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 3) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    }
  };

  var filteredData = props.userData;

  if (sortByDay !== 4) {
    filteredData = filteredData.filter((item) => {
      return (
        (startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
          startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
        (moment(item.createdAt).format("YYYY-MM-DD") <= endDay ||
          moment(item.updatedAt).format("YYYY-MM-DD") <= endDay)
      );
    });
  }
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-4">
          <div className="d-flex align-items-center pt-2 pb-1">
            <div className="f18_500_HelveticaNeue">
              {props.event && props.event.name}
            </div>
            <div className="enSuccessLBL ml-2">Online</div>
          </div>
          <div className="f12-400 text-red pb-4">
            Event ID: {props.event && props.event._id}
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-3">
          <div className="mr-3">
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="demo-simple-select-outlined-label">
                Select date range
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={sortByDay}
                onChange={(e) => changeSortByDay(e.target.value)}
                label="date_range"
              >
                {sortBy.map((data, index) => (
                  <MenuItem key={index} value={data.id}>
                    {data.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="col-2">
          <div className="d-flex align-items-center justify-content-between">
            <div className="f10-400" align="center">
              <img
                src={require("../../../assets/images/iconButton/sorticon.png")}
                width="35px"
              />
              <br />
              Sort
            </div>
            <div className="f10-400" align="center">
              <img
                src={require("../../../assets/images/iconButton/filtericon.png")}
                width="35px"
              />
              <br />
              Filter
            </div>
            <div className="f10-400" align="center">
              <img
                src={require("../../../assets/images/iconButton/downloadicon.png")}
                width="35px"
              />
              <br />
              Download
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Col md={6} lg={3} className="border-right pb-3">
          <div className="f12-700 mb-2">Event Date & Time</div>
          <div>
            <div>
              <div className="f10-500 mb-2">
                {moment(props.event && props.event.start_date).format(
                  "Do MMM YYYY"
                )}{" "}
                To{" "}
                {moment(props.event && props.event.end_date).format(
                  "Do MMM YYYY"
                )}
              </div>
              <div className="f10-500 mb-2">
                <Image
                  src={require("../../../assets/images/UserManagement/clock-red.svg")}
                  alt="Profile pic"
                  title="Profile Pic"
                  width="10px"
                />
                &nbsp;{" "}
                {moment(props.event && props.event.start_date).format(
                  "hh:mm A"
                )}{" "}
                to{" "}
                {moment(props.event && props.event.end_date).format("hh:mm A")}
              </div>

              {/* <div className="d-flex align-items-center">
              <Image
                src={require("../../assets/images/UserManagement/clock-red.svg")}
                alt="Profile pic"
                title="Profile Pic"
                width="10px"
              />
              <div className="f10-500 pl-2">07:00 PM</div>
            </div> */}
            </div>
            {/* <div className="f10-500 px-3">To</div>
          <div>
            <div className="f10-500 mb-2">14th Feb, 2021</div>
            <div className="d-flex align-items-center">
              <Image
                src={require("../../assets/images/UserManagement/clock-red.svg")}
                alt="Profile pic"
                title="Profile Pic"
                width="10px"
              />
              <div className="f10-500">
                <div className="ml-2">07:00 PM to 10:00 PM</div>
              </div>
            </div>
          </div> */}
          </div>
        </Col>
        <Col xs={6} lg={3} md={6} className="border-right pb-3">
          <div className="f12-700 mb-3">Hyperlink</div>
          <div className="f12-400 text-break">
            {props && props.event && props.event.eventLink}
          </div>
        </Col>
        <Col xs={6} lg={2} md={6} className="border-right pb-3">
          <div className="f12-700 mb-3">Event Joining Code</div>
          <div className="f12-400 text-break">
            {props.event && props.event.eventPassword}
          </div>
        </Col>
        <Col xs={6} lg={4} md={6} className="pb-3">
          <div className="d-flex seating-right-side-boxcount border-0">
            <div className="mr-5 text-center enWidth130">
              <CountBoxReusableSeatingComponent
                classSection="box-colorgray"
                count={
                  props && props.event && props.event.eventViews
                    ? props.event.eventViews
                    : 0
                }
                iconText="Total No of User viewed Event"
                iconTextStyle="colorgray"
              />
            </div>
            {/* <div className="mr-5 text-center enWidth130">
          <CountBoxReusableSeatingComponent
            classSection="box-colororange"
            count={90}
            iconText="Used Coupon"
            iconTextStyle="colororange"
          />
        </div> */}
            <div className="mr-5 text-center enWidth130">
              <CountBoxReusableSeatingComponent
                classSection="box-colordark_green"
                count={
                  props && props.event && props.event.eventUsed
                    ? props.event.eventUsed
                    : 0
                }
                iconText="Viewed Live Stream"
                iconTextStyle="colordark_green"
              />
            </div>
          </div>
        </Col>
      </Row>
      {/* <hr /> */}

      {/* // <hr /> */}
      {
        //   <Media query="(max-width: 991px)">
        //     <>
        //       <div className="row align-items-center seating-dashboard-table">
        //         <div className="col-5 mpr-1">
        //           <p className="f12-700 pl-3">User Name</p>
        //         </div>
        //         <div className="col-3 px-0">
        //           <p className="f12-700">
        //             Start Date &<br />
        //             <span className="text-red">
        //               Event <br />
        //               Viewed
        //             </span>
        //           </p>
        //         </div>
        //         <div className="col-4 mpl-1">
        //           <p className="f12-700">Viewed Date -Time</p>
        //         </div>
        //       </div>
        //       <div className="row">
        //         <div className="col-12 p-0">
        //           <Accordion>{renderEventAccordian()}</Accordion>
        //         </div>
        //       </div>
        //     </>
        //   </Media>
        //   <Media query="(min-width: 991px)">}
      }
      <div className="user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth500">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th className="f11-500" style={{ width: "20%" }}>
                User Name
              </th>
              <th className="f11-500" style={{ width: "20%" }}>
                Event
                <br />
                Viewed
              </th>
              <th className="f11-500" style={{ width: "20%" }}>
                Viewed
                <br />
                Date -Time
              </th>
              {/* <th className="f11-500" style={{ width: "10%" }}>
                Coupon
                <br />
                Used
              </th> */}
              <th className="f11-500" style={{ width: "20%" }}>
                Attended
                <br />
                Date -Time
              </th>
              <th className="f11-500" style={{ width: "20%" }}>
                Live stream <br />
                Viewed
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData &&
              filteredData.map((user, index) => (
                <tr className="enUserFavoritesTableBody" key={index}>
                  <td
                    style={{ width: "20%" }}
                    className="d-flex align-items-start"
                  >
                    <div className="d-flex flex-column align-items-center">
                      <div className="enIMG33 rounded-circle">
                        {user &&
                        user.user_id &&
                        user.user_id.profile_photo &&
                        user.user_id.profile_photo[0] ? (
                          <Image
                            src={user.user_id.profile_photo[0]}
                            alt="Profile pic"
                            title="Profile Pic"
                            className="h-100 w-100"
                            fluid
                          />
                        ) : (
                          <Image
                            src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                            alt="Profile pic"
                            title="Profile Pic"
                            className="h-100 w-100"
                            fluid
                          />
                        )}
                      </div>
                      <div className="f10-400 pt-2">
                        {user && user.user_id && user.user_id.first_name}{" "}
                        {user && user.user_id && user.user_id.last_name}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f10-500">
                      {user.event_viewed ? "Yes" : " No"}
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f10-500">
                      {" "}
                      {moment(user.event_viewed_time).format("DD-MM-YYYY")}
                    </div>
                    <div className="f10-400">
                      {moment(user.event_viewed_time).format("LT")}
                    </div>
                  </td>
                  {/* <td style={{ width: "10%" }}>
                <div className="f10-500">Yes</div>
              </td> */}
                  <td style={{ width: "20%" }}>
                    <div className="f10-500">
                      {" "}
                      {moment(user.live_stream_viewed_time).format(
                        "DD-MM-YYYY"
                      )}
                    </div>
                    <div className="f10-400">
                      {moment(user.live_stream_viewed_time).format("LT")}
                    </div>
                  </td>
                  {/* <td style={{ width: "10%" }}>
                <div className="f10-500">Yes</div>
              </td> */}
                  <td style={{ width: "20%" }}>
                    <div className="f10-500">
                      {" "}
                      <div className="f10-500">
                        {user.live_stream_viewed ? "Yes" : " No"}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      {/* </Media> */}
    </React.Fragment>
  );
};
